import { Divider, Typography, Grid } from "@material-ui/core";
import React, { Component } from "react";
import { withRouter } from 'react-router-dom';
import Skeleton from "react-loading-skeleton";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { getDecks, updateHeaderInfo, copyDeck, getUserDetails, getFlashCards } from "../actions";
import { FlashCardWidget, CopyrightWidget } from "../components";
import IconButton from "@material-ui/core/IconButton";
import AddIcon from '@material-ui/icons/Add';
import Modal from '@material-ui/core/Modal';
import { deviceData, setContainer, scrollTop, getThisYear } from "../common";
import { isBrowser, isElectron } from 'react-device-detect';

class FlashCardsScreen extends Component {
    state = {
        reload: false,
        copyModal: false,
        text: 'test...',
    }

    componentDidMount = async () => {
        await document.getElementById('root').scrollTo({top: 0, behavior: "smooth"});
        const { mcid, key } = this.props.auth_feedback;
        await this.props.getUserDetails( mcid, key, deviceData(this.props.location, 'navigate') );
        await this.props.getFlashCards({ mcid: mcid, key: key });
        return this.props.updateHeaderInfo({
            route:"/FlashCardScreen", 
            name: "Flashcards", 
            iconTwo: 'menu',
            iconOne: 'home',
        });
    };

    componentDidUpdate = async (prevProps, prevState) => {
        if (prevProps.getFlashCards !== this.props.getFlashCards) {
            scrollTop('FlashCardsScreenDiv');
        }
        
        if (this.state.reload) {
            this.setState({ ...this.state, reload: false});
        }
    }

    handleOpen = () => {
        this.setState({
            ...this.state,
            copyModal: true,
        });
    };

    handleClose = () => {
        this.setState({
            ...this.state,
            copyModal: false,
        });
    };

    setColorObj = (type = 'base') => {
        let r;

        switch (type) {
            default: {
                r = {
                    deck: "neutralGreenCard",
                    text: "neutralGreenText",
                    button: "neutralGreenCard"
                }
            }
        }
        return r;
    }

    mapMyDeckCards = () => {
        const deckList = this.props.flashCards;

        if (typeof deckList !== 'undefined' && deckList.length > 0) {            
            return deckList.map((deck, index) => {
                let percomp = Math.trunc((Number(deck.totaAnswered) / Number(deck.totalQuestions)) * 100);
                if (percomp > 100) { percomp = 100; }
                let colorObj = (typeof deck.deckColor !== 'undefined' ? this.setColorObj(deck.deckColor) : this.setColorObj());

                return (
                    <FlashCardWidget
                        deckColor={colorObj.deck}
                        textColor={colorObj.text}
                        buttonColor={colorObj.button}
                        index={index}
                        deckName={deck.deckname}
                        deckID={deck.deckID}
                        value={deck.totalQuestions}
                        gameMode={deck.gameMode}
                        deck={deck}
                        complete={percomp}
                        titleClass="deck-card-title"
                        copyDeck={() => this.copyThisDeck(deck.deckID)}
                        owner={Number(deck.owner)}
                        isWrong={deck.isWrong}
                        totalQuestions={deck.totalQuestions}
                    />
                );
            });
        }
    };

    render() {
        return (
            <>
                <div style={setContainer(isBrowser)} className=" aua-overflow" id="FlashCardsScreenDiv">
                    <Typography className="homeDividerText">My Flashcards</Typography>

                    <div className="deck-container" style={{ margin:"8px 0 16px", width: "calc(100%)" }}>
                        {this.mapMyDeckCards(this.props)}
                    </div>

                    <CopyrightWidget 
                        year={getThisYear()}
                        textAlign={'center'}
                        className="margin-top-8 padding-top-8 padding-bottom-24 padding-left-16 padding-right-16"
                    />
                </div>
            </>
        );
    }
}

const mapStateToProps = state => {
    const { auth_feedback, user_details } = state.auth;
    const { headerText, iconOne, iconTwo, backgroundcolor } = state.style;
    const { flashCards } = state.decks;
    return {
        headerText,
        iconOne,
        iconTwo,
        backgroundcolor,
        flashCards,
        auth_feedback,
        user_details
    };
};

export default connect(mapStateToProps, 
    { 
        updateHeaderInfo, getDecks, copyDeck, getUserDetails, getFlashCards
    })(withRouter(FlashCardsScreen));

// export { FlashCardsScreen };
